import { DenoIcon } from 'components/atomic/atoms/icons/logos/deno'
import { FreshIcon } from 'components/atomic/atoms/icons/logos/fresh'
import { KotlinIcon } from 'components/atomic/atoms/icons/logos/kotlin'
import { NextjsIcon } from 'components/atomic/atoms/icons/logos/nextjs'
import { NuxtIcon } from 'components/atomic/atoms/icons/logos/nuxt'
import { QwikIcon } from 'components/atomic/atoms/icons/logos/qwik'
import { ReactIcon } from 'components/atomic/atoms/icons/logos/react'
import { RemixIcon } from 'components/atomic/atoms/icons/logos/remix'
import { SolidjsIcon } from 'components/atomic/atoms/icons/logos/solidjs'
import { SveltekitIcon } from 'components/atomic/atoms/icons/logos/sveltekit'
import { SwiftIcon } from 'components/atomic/atoms/icons/logos/swift'
import { VueIcon } from 'components/atomic/atoms/icons/logos/vue'

const frameworks = [
  {
    name: 'React',
    icon: ReactIcon,
    href: '/frameworks/react',
  },
  {
    name: 'Next.js',
    icon: NextjsIcon,
    href: '/frameworks/nextjs',
  },
  {
    name: 'Remix',
    icon: RemixIcon,
    href: '/frameworks/remix',
  },
  {
    name: 'Vue',
    icon: VueIcon,
    href: '/frameworks/vue',
  },
  {
    name: 'Nuxt',
    icon: NuxtIcon,
    href: '/frameworks/nuxt',
  },
  {
    name: 'SvelteKit',
    icon: SveltekitIcon,
    href: '/frameworks/sveltekit',
  },
  {
    name: 'Swift',
    icon: SwiftIcon,
    href: '/frameworks/swift',
  },
  {
    name: 'Kotlin',
    icon: KotlinIcon,
    href: '/frameworks/kotlin',
  },
  {
    name: 'SolidJS',
    icon: SolidjsIcon,
    href: '/frameworks/solidjs',
  },
  {
    name: 'Qwik',
    icon: QwikIcon,
    href: '/frameworks/qwik',
  },
  {
    name: 'Fresh',
    icon: FreshIcon,
    href: '/frameworks/fresh',
  },
  {
    name: 'Deno',
    icon: DenoIcon,
    href: '/frameworks/deno',
  },
]

export default frameworks
